import React from "react";
import {
  Route,
  Routes,
  useParams,
  useLocation,
  BrowserRouter,
} from "react-router-dom";
import Layout from "./Layout";
import "./App.css";
import {
  HomePage,
  LoginPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  NavigationPage,
  CalendarPage,
  ValuationPage,
  DeliveryDataPage,
  PriceSectionPage,
  TextForm,
} from "./pages/index";

import Frontend from "./frontend/Frontend";

import publicIp from "public-ip";

import { GroupsPage, MyPdfViewer, SortDataPage } from "./pages/VDR";
import PDFView from "./pages/VDR/PDFView";
import { useDispatch } from "react-redux";
import { publicIpAction } from "./redux/actions/VdrAction";
import Tree from "./pages/VDR/Tree";
import LayoutVdr from "./LayoutVdr";
import { checkUser, getBaseLink } from "./constants/helpers";
import SingleCompany from "./pages/SingleCompany";
import INV from "./pages/INV";
import ProtectedRoute from "./ProtectedRoute";
import DashboardPage from "./admin/DashboardPage";
import UserListPage from "./admin/user/ListPage";


import LoginPageUser from "./pages/LoginPageUser";
import InsertNewUsers from "./admin/InsertNewUsers";



const PageNotFound = () => {
  return (
    <>
      <h2>page Not Found</h2>
    </>
  );
};

const App = (props) => {
  // publicIp.v4()

  const dispatch = useDispatch();
  React.useEffect(() => {
    checkUser();
  }, []);

  // 956936008951-lb9c7igeouria747k1a13gd7jdd1mcdm.apps.googleusercontent.com
  // const [ profile, setProfile ] = React.useState([]);
  //   const clientId = '956936008951-lb9c7igeouria747k1a13gd7jdd1mcdm.apps.googleusercontent.com';
  //   React.useEffect(() => {
  //     console.log('profile', profile);
  //     console.log('profile googleId', profile?.googleId);
  //       const initClient = () => {
  //           gapi.client.init({
  //               clientId: clientId,
  //               scope: ''
  //           });
  //       };
  //       gapi.load('client:auth2', initClient);
  //   }, [profile]);

  //   const onSuccess = (res) => {
  //       setProfile(res.profileObj);
  //   };

  //   const onFailure = (err) => {
  //       console.log('failed', err);
  //   };

  //   const logOut = () => {
  //       setProfile(null);
  //   };

  return (
    <>

      <BrowserRouter basename={getBaseLink()}>
        <Routes>
          <Route exact path="/user/login" element={<LoginPageUser />} />

          <Route exact path="/Tree" element={<Tree />} />
          <Route exact path="PDFView" element={<PDFView />} />
          <Route exact path="/MyPdfViewer" element={<MyPdfViewer />} />

          <Route path="/" element={<Frontend.Layout />}>
            <Route index element={
                <ProtectedRoute>
                  <Frontend.HomePage />
                </ProtectedRoute>
              } 
              />
            <Route
              exact
              path="/calendar"
              element={<CalendarPage dataFor="frontend" />}
            />
            <Route exact path="/small-case" element={<Frontend.SmallCase />} />
            <Route exact path="/videos" element={<Frontend.VideosPage />} />
            <Route
              exact
              path="/favorite-listing"
              element={<Frontend.FavoriteListing />}
            />
            <Route
              exact
              path="/single-company/:companyId"
              element={<SingleCompany />}
            />
            <Route
              exact
              path="/company-listing"
              element={<Frontend.CompanyListing />}
            />
            <Route
              exact
              path="/company/:companyName"
              element={<Frontend.CompanyDetail />}
            />
            {/* <Route exact path='/:companyName' element={<Frontend.CompanyOldDetail />} /> */}
          </Route>

          {/* <Route path="/admin" element={<LayoutVdr />}>
          <Route index element={
            <ProtectedRoute>
              <GroupsPage />
            </ProtectedRoute>
          } />
        </Route> */}

          <Route exact path="admin/login" element={<LoginPage />} />
          <Route path="/admin/" element={<Layout />}>
            <Route
              index
              element={
                <ProtectedRoute isAdmin={true}>
                  <UserListPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="users"
              element={
                <ProtectedRoute isAdmin={true}>
                  <UserListPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="groups-page"
              element={
                <ProtectedRoute isAdmin={true}>
                  <GroupsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="insert-new-users"
              element={
                <ProtectedRoute isAdmin={true}>
                  <InsertNewUsers />
                </ProtectedRoute>
              }
            />

            {/* <Route path="navigation" element={<NavigationPage />} />  
          <Route path="calendar" element={<CalendarPage dataFor="backend" />} />
          <Route path="valuation" element={<ValuationPage />} />
          <Route path="delivery-data" element={<DeliveryDataPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route path="text-form" element={<TextForm />} />
          <Route path="fii" element={<INV />} /> */}
          </Route>

          {/* 
        <Route path="/price" element={<Layout />}>
          <Route index element={<PriceSectionPage dataFor="backend" />} />
        </Route> */}

          {/* <Route path="/admin" element={<LayoutVdr />}>
          <Route index element={<GroupsPage />} />
        </Route> */}

          {/* <Route path="/" element={<Layout />}> 
          <Route index element={<HomePage />} />
          <Route path="navigation" element={<NavigationPage />} />  
          <Route path="calendar" element={<CalendarPage dataFor="backend" />} />
          <Route path="valuation" element={<ValuationPage />} />
          <Route path="delivery-data" element={<DeliveryDataPage />} />
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route path="text-form" element={<TextForm />} />
          <Route path="fii" element={<INV />} />
          <Route exact path='/single-company/:companyId' element={<SingleCompany />} />
        </Route> */}

          {/* <Route path="/calendar/assign" element={<Layout />}>
          <Route index element={<CalendarPage dataFor="backend" />} />
        </Route> 

        <Route path="/list" element={<Layout />}>
          <Route index element={<PriceSectionPage dataFor="backend" />} />
        </Route> */}

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
